common.View.create('project::website.modules.projects.Index', {

    map: null,
    infowindow: null,

    onDOMLoad() {
        this.initMap();
    },

    initMap()
    {
        let apiKey = this.element.find('.apiKey').text();

        // Check when script is done loading
        $.getScript('https://maps.googleapis.com/maps/api/js?key='+ apiKey +'&libraries=places&callback=project.website.modules.projects.Index', () => {
            this.setupMap();
        });
    },

    setupMap()
    {
        // Map options
        var options = {
            zoom: 8,
            center: new google.maps.LatLng(51.8920229, 5.1867626),
            styles: this.mapStyling(),
            disableDefaultUI: true,
        };

        // New map
        this.map = new google.maps.Map(document.getElementById('map'), options);

        let locations = JSON.parse(this.element.find('#map').attr('data-locations'));

        // Loop through locations and add marker
        for (let i = 0; i < locations.length; i++) {
            this.addMarker(locations[i], {
                coords: {lat: parseFloat(locations[i].lat), lng: parseFloat(locations[i].lng)}
            });
        }
    },

    mapStyling()
    {
        return [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color":
        "#333333" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke",
        "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "all",
        "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType":
        "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness":
        20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ {
        "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType":
        "administrative.country", "elementType": "geometry.stroke", "stylers": [ { "visibility": "on" }, {
        "color": "#dddddd" } ] }, { "featureType": "administrative.province", "elementType":
        "labels.text", "stylers": [ { "visibility": "off" }, { "color": "#2b2b2b" } ] }, { "featureType":
        "administrative.locality", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, {
        "featureType": "administrative.land_parcel", "elementType": "labels.text", "stylers": [ {
        "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ {
        "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "landscape.natural.landcover",
        "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType":
        "landscape.natural.terrain", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, {
        "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness":
        21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color":
        "#dedede" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType":
        "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType":
        "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness":
        29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers":
        [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType":
        "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "transit",
        "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, {
        "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, {
        "lightness": 17 } ] }, { "featureType": "water", "elementType": "labels.text", "stylers": [ {
        "visibility": "off" } ] } ];
    },

    addMarker(location, props)
    {
        // Create a custom overlay for the marker with box shadow
        class CustomMarker extends google.maps.OverlayView {
            constructor(position, map, location) {
                super();
                this.position = position;
                this.location = location;
                this.setMap(map);
            }

            onAdd() {
                this.div = document.createElement('div');
                this.div.className = 'custom-map-marker';
                this.div.style.position = 'absolute';
                this.div.style.cursor = 'pointer';
                this.div.innerHTML = `<img src="/img/website/mapIcon.svg" style="width: 40px; height: 40px;">`;
                
                const panes = this.getPanes();
                panes.overlayMouseTarget.appendChild(this.div);
                
                // Trigger callback when div is ready
                if (this.onReady) {
                    this.onReady();
                }
            }

            draw() {
                const overlayProjection = this.getProjection();
                const position = overlayProjection.fromLatLngToDivPixel(this.position);
                
                if (this.div) {
                    this.div.style.left = (position.x - 20) + 'px';
                    this.div.style.top = (position.y - 40) + 'px';
                }
            }

            onRemove() {
                if (this.div) {
                    this.div.parentNode.removeChild(this.div);
                    this.div = null;
                }
            }

            getDiv() {
                return this.div;
            }
        }

        const customMarker = new CustomMarker(props.coords, this.map, location);
        
        // Store reference for info window
        let marker = {
            customMarker: customMarker,
            position: props.coords
        };

        console.log( location );
        // Info Window Content
        var contentString = `
            <div class="min-w-[160px] max-w-sm">
                <img src="` + location.image + `" class="w-full aspect-[16/9] object-cover" alt="Image Alt Text">
                <div class="bg-white flex flex-col items-start p-6 py-5">
                    <div class="bg-primary text-white px-4 py-2 font-medium text-xs rounded-lg">` + (location.subtitle || '') + `</div>
                    <h3 class="text-lg text-primary font-bold my-2">` + location.title + `</h3>
                </div>
            </div>`;

        // Add Info Window
        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            disableAutoPan: true
        });

        // Add Listener when marker is ready
        customMarker.onReady = () => {
            customMarker.getDiv().addEventListener("click", () => {
                infowindow.setPosition(props.coords);
                infowindow.open(this.map);
            });
        };
    }

});